import { ActionReducerMap } from '@ngrx/store';

import { oauthReducer, toastReducer as sharedToastReducer } from '@digihaven/shared';

import { authenticationReducer } from '@reducers/authentication/authentication.reducer';
import { reducer as functionalityReducer } from '@reducers/functionality/functionality.reducer';

import { ApplicationState } from 'state';

import { organisationReducer } from './organisation/organisation.reducer';
import { tokenReducer } from './token/token.reducer';
import { userReducer } from './user/user.reducer';

export const rootReducer: ActionReducerMap<ApplicationState> = {
    authentication: authenticationReducer,
    token: tokenReducer,
    functionality: functionalityReducer,
    user: userReducer,
    organisation: organisationReducer,
    sharedToast: sharedToastReducer,
    oauth: oauthReducer
};
